let formatearDateFrom = function() {
	this.dateFrom = new Date(
		(new Date(this.dateFrom).toISOString() + "").slice(0, 10) +
		"T23:31:04.000Z"
		).toISOString();
};
export default formatearDateFrom;
